import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist()

export const lpaManagementQuestionsState = atom({
  key: 'lpaManagementQuestionsState',
  default: {
    LPAQuestions: [],
  },
  effects_UNSTABLE: [persistAtom],
});

